import { createSelector } from 'reselect';
import get from 'lodash/get';
import config from '../config';

const selectData = state => state.data;

const selectKeysFromProps = (_, props) => props.keys;

export const selectCurrentData = createSelector(
  selectData,
  data => data.current,
)

export const selectSensorsCurrent = createSelector(
  selectCurrentData,
  (current) => current.sensors.filter(sensor => sensor.data),
);

export const selectTemperatureSensors = createSelector(
  selectSensorsCurrent,
  sensors => sensors.filter(
    // ({ sensor_type, data_structure_type }) => sensor_type === 45 && data_structure_type === 10,
    ({ data }) => data[0] && !!data[0].temp_last,
  ),
);

export const selectStations = createSelector(
  selectData,
  data => data.stations.stations.map(station => ({
    ...station,
    x: config.nodes[station.gateway_id].x,
    y: config.nodes[station.gateway_id].y,
  })),
)

export const selectNodes = createSelector(
  selectData,
  data => data.nodes.nodes.map(node => ({
    ...node,
    x: config.nodes[node.device_id].x,
    y: config.nodes[node.device_id].y,
  })),
)

export const selectDevices = createSelector(
  selectNodes,
  selectStations,
  (nodes, stations) => [...nodes, ...stations],
)

export const selectSensorMeta = createSelector(
  selectData,
  (data) => data.sensors.sensors.map(sensor => ({
    ...sensor,
    x: config.nodes[sensor.parent_device_id].x,
    y: config.nodes[sensor.parent_device_id].y,
  })),
)

export const selectReadingsByNode = createSelector(
  selectDevices,
  selectKeysFromProps,
  selectSensorsCurrent,
  selectSensorMeta,
  (nodes, keys, sensors, sensorMeta) => nodes.map((node, i) => ({
    ...node,
    data: keys.map(key => {
      // if (key === 'wind_dir_last_deg') console.log(matchingSensors)
      const matchingSensors = sensors
        .filter(({ lsid }) => {
          const { parent_device_id } = sensorMeta.find(sensor => sensor.lsid === lsid);
          return parent_device_id === node.device_id || parent_device_id === node.gateway_id;
        })
        .filter(({ data }) => get(data, [0, key]) !== undefined)
      // if (key === 'wind_dir_last_deg') console.log(matchingSensors)
      return get(matchingSensors, [0, 'data', 0, key]) // TODO: Handle multiple matches
    })
  }))
)

export const selectIsFetching = createSelector(
  selectData,
  data => data.pending,
)




// WEBPACK FOOTER //
// ./src/store/selectors.js